/* eslint-disable arrow-body-style */
/* eslint-disable no-nested-ternary */
import React from 'react';
import './styles.scss';

/**
 * Stepper component
 * @param {Object} props
 * @param {number} props.step - Current step (1-based)
 * @param {Array<{label: string, subTitle: string}>} props.steps - Steps array
 */
const Stepper = ({ step, steps }) => {
  return (
    <div className="import__header">
      {steps.map((stepObj, idx) => {
        const num = idx + 1;
        const status = step === num
          ? 'import--active'
          : step > num
            ? 'import--complete'
            : '';
        return (
          <div key={num} className={`import__step ${status}`}>
            <div className="import__circle">{num}</div>
            <div className="import__label">{stepObj.subTitle}</div>
          </div>
        );
      })}
    </div>
  );
};

export default Stepper;
